import BaseModel from '../Base';

export default class Team extends BaseModel {
  static entity = 'teams';

  static fields() {
    return {
      ...super.fields(),
      name: this.string(''),
      logo: this.string(''),
      domain: this.string(''),
      isUnlocked: this.boolean(true)
    };
  }
}
